// source: witbooking/backoffice/mealplan/v1/mealplan_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.MealPlan', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.Translation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.displayName = 'proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.displayName = 'proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.displayName = 'proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.displayName = 'proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.displayName = 'proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.displayName = 'proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.displayName = 'proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.displayName = 'proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.displayName = 'proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.displayName = 'proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.displayName = 'proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.displayName = 'proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.displayName = 'proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.displayName = 'proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.displayName = 'proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.displayName = 'proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.mealplan.v1.MealPlan.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.MealPlan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.MealPlan.displayName = 'proto.witbooking.backoffice.mealplan.v1.MealPlan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.mealplan.v1.Translation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.mealplan.v1.Translation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.mealplan.v1.Translation.displayName = 'proto.witbooking.backoffice.mealplan.v1.Translation';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest;
  return proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    mealPlan: (f = msg.getMealPlan()) && proto.witbooking.backoffice.mealplan.v1.MealPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse;
  return proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.mealplan.v1.MealPlan;
      reader.readMessage(value,proto.witbooking.backoffice.mealplan.v1.MealPlan.deserializeBinaryFromReader);
      msg.setMealPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMealPlan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.mealplan.v1.MealPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional MealPlan meal_plan = 1;
 * @return {?proto.witbooking.backoffice.mealplan.v1.MealPlan}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.prototype.getMealPlan = function() {
  return /** @type{?proto.witbooking.backoffice.mealplan.v1.MealPlan} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.mealplan.v1.MealPlan, 1));
};


/**
 * @param {?proto.witbooking.backoffice.mealplan.v1.MealPlan|undefined} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse} returns this
*/
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.prototype.setMealPlan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse} returns this
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.prototype.clearMealPlan = function() {
  return this.setMealPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.prototype.hasMealPlan = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest;
  return proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    mealPlansList: jspb.Message.toObjectList(msg.getMealPlansList(),
    proto.witbooking.backoffice.mealplan.v1.MealPlan.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse;
  return proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.mealplan.v1.MealPlan;
      reader.readMessage(value,proto.witbooking.backoffice.mealplan.v1.MealPlan.deserializeBinaryFromReader);
      msg.addMealPlans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMealPlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.mealplan.v1.MealPlan.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MealPlan meal_plans = 1;
 * @return {!Array<!proto.witbooking.backoffice.mealplan.v1.MealPlan>}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.prototype.getMealPlansList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.mealplan.v1.MealPlan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.mealplan.v1.MealPlan, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.mealplan.v1.MealPlan>} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse} returns this
*/
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.prototype.setMealPlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.MealPlan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.mealplan.v1.MealPlan}
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.prototype.addMealPlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.mealplan.v1.MealPlan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse} returns this
 */
proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.prototype.clearMealPlansList = function() {
  return this.setMealPlansList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mealPlan: (f = msg.getMealPlan()) && proto.witbooking.backoffice.mealplan.v1.MealPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest;
  return proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.mealplan.v1.MealPlan;
      reader.readMessage(value,proto.witbooking.backoffice.mealplan.v1.MealPlan.deserializeBinaryFromReader);
      msg.setMealPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMealPlan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.mealplan.v1.MealPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MealPlan meal_plan = 2;
 * @return {?proto.witbooking.backoffice.mealplan.v1.MealPlan}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.prototype.getMealPlan = function() {
  return /** @type{?proto.witbooking.backoffice.mealplan.v1.MealPlan} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.mealplan.v1.MealPlan, 2));
};


/**
 * @param {?proto.witbooking.backoffice.mealplan.v1.MealPlan|undefined} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest} returns this
*/
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.prototype.setMealPlan = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.prototype.clearMealPlan = function() {
  return this.setMealPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest.prototype.hasMealPlan = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    mealPlan: (f = msg.getMealPlan()) && proto.witbooking.backoffice.mealplan.v1.MealPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse;
  return proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.mealplan.v1.MealPlan;
      reader.readMessage(value,proto.witbooking.backoffice.mealplan.v1.MealPlan.deserializeBinaryFromReader);
      msg.setMealPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMealPlan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.mealplan.v1.MealPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional MealPlan meal_plan = 1;
 * @return {?proto.witbooking.backoffice.mealplan.v1.MealPlan}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.prototype.getMealPlan = function() {
  return /** @type{?proto.witbooking.backoffice.mealplan.v1.MealPlan} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.mealplan.v1.MealPlan, 1));
};


/**
 * @param {?proto.witbooking.backoffice.mealplan.v1.MealPlan|undefined} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse} returns this
*/
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.prototype.setMealPlan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse} returns this
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.prototype.clearMealPlan = function() {
  return this.setMealPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.prototype.hasMealPlan = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mealPlan: (f = msg.getMealPlan()) && proto.witbooking.backoffice.mealplan.v1.MealPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest;
  return proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.mealplan.v1.MealPlan;
      reader.readMessage(value,proto.witbooking.backoffice.mealplan.v1.MealPlan.deserializeBinaryFromReader);
      msg.setMealPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMealPlan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.mealplan.v1.MealPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MealPlan meal_plan = 2;
 * @return {?proto.witbooking.backoffice.mealplan.v1.MealPlan}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.prototype.getMealPlan = function() {
  return /** @type{?proto.witbooking.backoffice.mealplan.v1.MealPlan} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.mealplan.v1.MealPlan, 2));
};


/**
 * @param {?proto.witbooking.backoffice.mealplan.v1.MealPlan|undefined} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest} returns this
*/
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.prototype.setMealPlan = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.prototype.clearMealPlan = function() {
  return this.setMealPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest.prototype.hasMealPlan = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse;
  return proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest;
  return proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse;
  return proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    after: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest;
  return proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAfter();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string after = 3;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.prototype.getAfter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest.prototype.setAfter = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse;
  return proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest;
  return proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse;
  return proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mealPlan: (f = msg.getMealPlan()) && proto.witbooking.backoffice.mealplan.v1.MealPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest;
  return proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.mealplan.v1.MealPlan;
      reader.readMessage(value,proto.witbooking.backoffice.mealplan.v1.MealPlan.deserializeBinaryFromReader);
      msg.setMealPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMealPlan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.mealplan.v1.MealPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MealPlan meal_plan = 2;
 * @return {?proto.witbooking.backoffice.mealplan.v1.MealPlan}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.prototype.getMealPlan = function() {
  return /** @type{?proto.witbooking.backoffice.mealplan.v1.MealPlan} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.mealplan.v1.MealPlan, 2));
};


/**
 * @param {?proto.witbooking.backoffice.mealplan.v1.MealPlan|undefined} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest} returns this
*/
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.prototype.setMealPlan = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest} returns this
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.prototype.clearMealPlan = function() {
  return this.setMealPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest.prototype.hasMealPlan = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    mealPlan: (f = msg.getMealPlan()) && proto.witbooking.backoffice.mealplan.v1.MealPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse;
  return proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.mealplan.v1.MealPlan;
      reader.readMessage(value,proto.witbooking.backoffice.mealplan.v1.MealPlan.deserializeBinaryFromReader);
      msg.setMealPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMealPlan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.mealplan.v1.MealPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional MealPlan meal_plan = 1;
 * @return {?proto.witbooking.backoffice.mealplan.v1.MealPlan}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.prototype.getMealPlan = function() {
  return /** @type{?proto.witbooking.backoffice.mealplan.v1.MealPlan} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.mealplan.v1.MealPlan, 1));
};


/**
 * @param {?proto.witbooking.backoffice.mealplan.v1.MealPlan|undefined} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse} returns this
*/
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.prototype.setMealPlan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse} returns this
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.prototype.clearMealPlan = function() {
  return this.setMealPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.prototype.hasMealPlan = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.MealPlan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.MealPlan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.mealplan.v1.Translation.toObject, includeInstance),
    mapTo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    inUse: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.MealPlan}
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.MealPlan;
  return proto.witbooking.backoffice.mealplan.v1.MealPlan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.MealPlan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.MealPlan}
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.mealplan.v1.Translation;
      reader.readMessage(value,proto.witbooking.backoffice.mealplan.v1.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapTo(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInUse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.MealPlan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.MealPlan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.backoffice.mealplan.v1.Translation.serializeBinaryToWriter
    );
  }
  f = message.getMapTo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInUse();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.MealPlan} returns this
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.MealPlan} returns this
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Translation translations = 3;
 * @return {!Array<!proto.witbooking.backoffice.mealplan.v1.Translation>}
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.mealplan.v1.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.mealplan.v1.Translation, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.mealplan.v1.Translation>} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.MealPlan} returns this
*/
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.mealplan.v1.Translation}
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.backoffice.mealplan.v1.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.mealplan.v1.MealPlan} returns this
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional string map_to = 4;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.getMapTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.MealPlan} returns this
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.setMapTo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool in_use = 5;
 * @return {boolean}
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.getInUse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.MealPlan} returns this
 */
proto.witbooking.backoffice.mealplan.v1.MealPlan.prototype.setInUse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.mealplan.v1.Translation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.mealplan.v1.Translation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.mealplan.v1.Translation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.Translation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.mealplan.v1.Translation}
 */
proto.witbooking.backoffice.mealplan.v1.Translation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.mealplan.v1.Translation;
  return proto.witbooking.backoffice.mealplan.v1.Translation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.mealplan.v1.Translation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.mealplan.v1.Translation}
 */
proto.witbooking.backoffice.mealplan.v1.Translation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.mealplan.v1.Translation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.mealplan.v1.Translation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.mealplan.v1.Translation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.mealplan.v1.Translation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.Translation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.Translation} returns this
 */
proto.witbooking.backoffice.mealplan.v1.Translation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.Translation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.Translation} returns this
 */
proto.witbooking.backoffice.mealplan.v1.Translation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.mealplan.v1.Translation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.mealplan.v1.Translation} returns this
 */
proto.witbooking.backoffice.mealplan.v1.Translation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.mealplan.v1);
